import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectVsicById } from '../../../common/filterCompany/store/sliceIndustry'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { Loading } from '../../../common/loading'
import { Panel } from '../../../common/panel'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../common/selectCurrencyUnit/useFormatCurrency'
import { TableItem } from './TableItem'
import {
  resetStore,
  selectBusinessSizeById,
  selectBusinessSizeIds,
  selectLoading,
  selectTopIndustryById,
  selectTopIndustryIds,
  selectTopProvinceById,
  selectTopProvinceIds,
  selectYearOfOperationById,
  selectYearOfOperationIds,
} from './store/slice'
import {
  exportPortfolioSegment,
  getBussinessSize,
  getTopByIndustry,
  getTopByProvince,
  getYearOfOperation,
} from './store/thunk'

export const PortfolioSegmentation = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const vsicById = useSelector(selectVsicById())
  const settingParams = useSettingParams()
  const { currency } = useFormatCurrency(SCREEN.PORTFOLIO_INSIGHTS)
  const topIndustryIds = useSelector(selectTopIndustryIds)
  const topProvinceIds = useSelector(selectTopProvinceIds)
  const businessSizeIds = useSelector(selectBusinessSizeIds)
  const yearsOperationIds = useSelector(selectYearOfOperationIds)
  const isLoading = useSelector(selectLoading())

  useEffect(() => {
    if (!settingParams) return
    const payload = { ...settingParams, currency }
    dispatch(getTopByIndustry(payload))
    dispatch(getTopByProvince(payload))
    dispatch(getBussinessSize(payload))
    dispatch(getYearOfOperation(payload))
  }, [settingParams, currency, locale])

  useEffect(() => {
    return () => resetStore()
  }, [])

  const downloadCsv = {
    downloadFunc: () => exportPortfolioSegment({ ...settingParams, currency }),
    disabled: !settingParams,
  }

  return (
    <Panel
      label="portfolio.summary.PORTFOLIO_SEGMENTATION"
      isI18n
      className="positionRelative"
      headerStyle={{ textTransform: 'capitalize' }}
      downloadCsv={downloadCsv}
    >
      {isLoading && <Loading />}
      <div className="dFlex gap4 pb2" style={{ opacity: isLoading ? 0 : 1 }}>
        <div className="flex1 minW0">
          <TableItem
            title="portfolio.summary.TOP_10_INDUSTRIES"
            subTitle="portfolio.summary.TOP_10_INDUSTRIES_SUB"
            indicatorName="INDUSTRY"
            ids={topIndustryIds}
            getDataFromRedux={selectTopIndustryById}
            detailParamKey="vsicId"
            formatNameCell={(id) => vsicById[id]?.name}
            segmentation="Industry"
          />
        </div>
        <div className="flex1 minW0">
          <TableItem
            title="portfolio.summary.TOP_10_PROVINCES"
            indicatorName="PROVINCE"
            ids={topProvinceIds}
            getDataFromRedux={selectTopProvinceById}
            detailParamKey="locationId"
            segmentation="Province"
          />
        </div>
      </div>

      <div className="dFlex gap4 pb2" style={{ opacity: isLoading ? 0 : 1 }}>
        <div className="flex1 minW0">
          <TableItem
            title="portfolio.summary.BUSINESS_SIZE_DISTRIBUTION"
            indicatorName="BUSINESS_SIZE_BY_REVENUE"
            ids={businessSizeIds}
            getDataFromRedux={selectBusinessSizeById}
            detailParamKey="businessSizeId"
            segmentation="BusinessSize"
          />
        </div>
        <div className="flex1 minW0">
          <TableItem
            title="portfolio.summary.YEARS_OF_OPERATION_DISTRIBUTION"
            indicatorName="YEARS_OF_OPERATION"
            ids={yearsOperationIds}
            getDataFromRedux={selectYearOfOperationById}
            detailParamKey="yearOfOperationId"
            segmentation="YearOfOperation"
          />
        </div>
      </div>
    </Panel>
  )
}
